import { Component, OnInit, Input, ViewChild } from '@angular/core'
import { Store } from '@ngrx/store'
import {
  BdcContentV2Service,
  BdcLicenseRequirementsWithValues,
  BdcSendLicenseInfoPayloadData,
} from '@tokeet-frontend/channel-content'
import { ActionFailed, compactObject, isSomething, Toaster } from '@tokeet-frontend/tv3-platform'
import { finalize, switchMap, tap } from 'rxjs/operators'
import { BdcLicensesFormComponent } from '../../bdc-licenses-form/bdc-licenses-form.component'

@Component({
  selector: 'app-bdc-property-licenses',
  templateUrl: './bdc-property-licenses.component.html',
  styleUrls: ['./bdc-property-licenses.component.scss'],
})
export class BdcPropertyLicensesComponent implements OnInit {
  @ViewChild('licenseForm') licenseForm: BdcLicensesFormComponent

  @Input() propertyId: number

  licenses: BdcLicenseRequirementsWithValues
  isLicenseRequired = true

  isLoading = true
  constructor(private store: Store<any>, private toaster: Toaster, private contentService: BdcContentV2Service) {}

  ngOnInit(): void {
    this.load().subscribe(
      () => {},
      (error) => {
        this.store.dispatch(ActionFailed({ error }))
      }
    )
  }

  load() {
    return this.contentService.getPropertyLicenses(this.propertyId).pipe(
      finalize(() => {
        this.isLoading = false
      }),
      tap((data) => {
        this.licenses = data
        this.isLicenseRequired = isSomething(compactObject(data))
      })
    )
  }

  onSave() {
    const payload: BdcSendLicenseInfoPayloadData = this.licenseForm?.getFormData()
    if (!payload) {
      return
    }

    this.isLoading = true
    this.contentService
      .updatePropertyLicenses(this.propertyId, payload)
      .pipe(
        switchMap(() => this.load()),
        finalize(() => (this.isLoading = false))
      )
      .subscribe(
        () => {
          this.toaster.success($localize`Property licenses updated successfully`)
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }
}
